import { PartnersLayout } from "./PartnersLayout";
import { PartnersSkeleton } from "./PartnersSkeleton";

/**
 * Full-page skeleton for the Partners route's pendingComponent.
 * Uses PartnersLayout for shared table headers and renders PartnersSkeleton rows.
 */
export function PartnersPageSkeleton() {
	return (
		<PartnersLayout onCreateClick={() => {}}>
			<PartnersSkeleton />
		</PartnersLayout>
	);
}
